import {
  PromotionsLayout,
  PromotionsMobileLayout,
  EmagazineMobileLayout,
  EmagazineLayout,
} from '@/features/blog/layout';

export { PromotionsLayout, EmagazineMobileLayout, PromotionsMobileLayout, EmagazineLayout };
